import React, { useState, useEffect } from 'react';
import './Projects.css';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    // Static data for now - will connect to backend later
    const staticProjects = [
      {
        id: 1,
        title: 'E-Commerce Platform',
        description:
          'A full-featured online store with inventory, payments, and analytics.',
        details:
          'We built a scalable e-commerce platform that supports multiple storefronts, role-based dashboards for admins and vendors, and real-time inventory synchronization with warehouse systems. Integrated payment gateways support cards, UPI, and wallets, while the analytics module tracks conversions, customer cohorts, and product performance to help business owners make better decisions.',
        image: '🛒',
        technology: 'React, Node.js, MongoDB, Stripe',
        project_url: '#',
      },
      {
        id: 2,
        title: 'Fitness Tracking App',
        description:
          'Cross-platform mobile app for workouts, nutrition, and progress.',
        details:
          'This app lets users log workouts, track calories, and connect wearables for steps and heart rate. We implemented personalized workout plans, push notification reminders, social leaderboards, and in-app purchases for premium programs, all backed by a secure, real-time cloud backend.',
        image: '💪',
        technology: 'React Native, Firebase, Google Fit / Apple Health',
        project_url: '#',
      },
      {
        id: 3,
        title: 'CRM System',
        description:
          'Enterprise CRM with advanced reporting and automation.',
        details:
          'For a B2B client, we delivered a CRM that centralizes leads, opportunities, and customer interactions. Features include email integration, task automation, sales pipelines, and rich reporting dashboards. Role-based access control and audit trails keep data secure and compliant.',
        image: '📊',
        technology: 'Vue.js, Django, PostgreSQL, Redis',
        project_url: '#',
      },
      {
        id: 4,
        title: 'Food Delivery App',
        description:
          'On-demand food delivery with real-time order tracking.',
        details:
          'This solution includes customer, restaurant, and delivery partner apps plus an admin portal. We implemented live order tracking on a map, dynamic delivery fee calculation, coupon management, rating and review flows, and a robust dispatch algorithm to match orders to nearby riders quickly.',
        image: '🍕',
        technology: 'Flutter, Node.js, Redis, Google Maps APIs',
        project_url: '#',
      },
      {
        id: 5,
        title: 'Learning Management System',
        description:
          'E-learning platform with video courses and assessments.',
        details:
          'The LMS supports video streaming, quizzes, assignments, certificates, and instructor dashboards. We added drip content scheduling, discussion forums, and detailed learner analytics so trainers can see completion rates, quiz scores, and engagement across their courses.',
        image: '📚',
        technology: 'React, Django, AWS (S3, CloudFront)',
        project_url: '#',
      },
      {
        id: 6,
        title: 'IoT Monitoring Dashboard',
        description:
          'Real-time dashboard for fleets of connected devices.',
        details:
          'We created a data visualization layer for thousands of IoT devices sending telemetry every few seconds. The system aggregates metrics, shows live and historical charts, triggers alerts on thresholds, and lets operators drill into individual device logs to quickly diagnose issues.',
        image: '📡',
        technology: 'Angular, Python, InfluxDB, MQTT',
        project_url: '#',
      },
    ];
    setProjects(staticProjects);
    setSelectedProject(staticProjects[0]);
  }, []);

  const handleSelectProject = (project) => {
    setSelectedProject(project);
    const details = document.getElementById('project-details');
    if (details) {
      details.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  return (
    <section id="projects" className="section">
      <div className="container">
        <h2 className="section-title">Our Projects</h2>
        <div className="projects-grid">
          {projects.map((project) => (
            <button
              key={project.id}
              type="button"
              className={`project-card${
                selectedProject && selectedProject.id === project.id
                  ? ' project-card--active'
                  : ''
              }`}
              onClick={() => handleSelectProject(project)}
            >
              <div className="project-image">
                <span className="project-emoji">{project.image}</span>
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tech">
                  <span className="tech-label">Technology:</span>
                  <span className="tech-stack">{project.technology}</span>
                </div>
                <span className="project-link">
                  View details →
                </span>
              </div>
            </button>
          ))}
        </div>

        {selectedProject && (
          <div id="project-details" className="project-details">
            <h3 className="project-details-title">
              <span className="project-details-icon">
                {selectedProject.image}
              </span>
              {selectedProject.title}
            </h3>
            <p className="project-details-text">
              {selectedProject.details}
            </p>
            <p className="project-details-tech">
              <span className="project-details-tech-label">Stack used:</span>
              <span className="project-details-tech-stack">
                {selectedProject.technology}
              </span>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Projects;
